import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { FiltersStore } from "./FiltersStore";
import { SearchFilter } from "@/components/filters";
export class ChargingStationsStore {
    constructor(chargingStationService) {
        this.chargingStationService = chargingStationService;
        this.loading = false;
        this.initializeChargingStationFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по номеру зарядной станции...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: {
                search: "",
                status: undefined,
            },
            dataLoader: {
                loadData: (params) => this.loadStations(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeChargingStationFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadStations(params) {
        try {
            const result = await this.chargingStationService.getStationsWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params?.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: result.page,
                pageSize: result.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteStation(id) {
        this.setLoading(true);
        try {
            await this.chargingStationService.deleteStation(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting charging station");
        }
        finally {
            this.setLoading(false);
        }
    }
}
